<mat-table [dataSource]="tableData" class="mat-table">

  <!-- Checkbox Column -->
  <ng-container matColumnDef="select">
    <mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        color="primary"
        (change)="$event ? masterToggle() : null"
        [checked]="isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()"
        [aria-label]="checkboxLabel()">
      </mat-checkbox>
    </mat-header-cell>
    <mat-cell *matCellDef="let row">
      <mat-checkbox
        color="primary"
        (click)="$event.stopPropagation()"
        (change)="$event ? selection.toggle(row) : null"
        [checked]="selection.isSelected(row)"
        [aria-label]="checkboxLabel(row)">
      </mat-checkbox>
    </mat-cell>
  </ng-container>

  <!-- Dynamic Columns -->
  <!-- Dynamic Columns -->
  <ng-container *ngFor="let column of columnDef" [matColumnDef]="column.key">
    <mat-header-cell *matHeaderCellDef> {{ column.header }}</mat-header-cell>
    <mat-cell *matCellDef="let element"> {{ getNestedValue(element, column.key) }}</mat-cell>
  </ng-container>


  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>

<mat-paginator [length]="dataSource().count"
               [pageSizeOptions]="[20, 50, 100]"
               (page)="onPageChange($event)"
               showFirstLastButtons
               aria-label="Select page of periodic elements">
</mat-paginator>
